import { Button, Form, Input, Row, Typography, Alert } from 'antd'
import './ForgotPassword.style.less'
import logoBackground from '../../../assets/images/fingertip-bg-ellipse.png'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FORM_TEXT, MESSAGE_TEXT } from '@/config/translation/text'

function ForgotPassword() {
  const { Title } = Typography
  const { t } = useTranslation()

  const [EmailSendStatus, setEmailSendStatus] = useState(false)
  const [EmailSendFail, setEmailSendFail] = useState(false)
  const [IsLoading, setIsLoading] = useState(false)

  const onFinish = async (values: any) => {
    setIsLoading(true)
  }

  return (
    <div className="login-container">
      {EmailSendStatus && (
        <Alert
          message={t(MESSAGE_TEXT.EMAIL_RESET_PASSWORD_SENT)}
          type="success"
          className="email-success-alert"
          banner
          showIcon
          closable
        />
      )}
      {EmailSendFail && (
        <Alert
          message={t(MESSAGE_TEXT.SOMETHING_WRONG)}
          className="email-error-alert"
          type="error"
          banner
          showIcon
          closable
        />
      )}
      <Form
        className="login-form"
        name="basic"
        layout="vertical"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label={t(MESSAGE_TEXT.ENTER_EMAIL_RESET_PASSWORD)}
          name="email"
          style={{ marginTop: '30px' }}
          rules={[
            {
              type: 'email',
              message: t(MESSAGE_TEXT.EMAIL_NOT_VALID),
            },
            {
              required: true,
              message: t(MESSAGE_TEXT.EMAIL_REQUIRED),
            },
          ]}
        >
          <Input
            size="large"
            placeholder={t(FORM_TEXT.EMAIL_ADDRESS)}
            style={{ minWidth: '370px' }}
          />
        </Form.Item>

        <Form.Item>
          <Row align="middle" justify="center">
            <div className="mock-block" style={{ marginTop: '30px' }}>
              <Button
                size="large"
                className="login-button"
                htmlType="submit"
                type="primary"
                disabled={IsLoading}
              >
                <Title level={5}>{t(FORM_TEXT.CONTINUE)}</Title>
              </Button>
            </div>
          </Row>
        </Form.Item>
      </Form>
      <img className="background-logo" src={logoBackground} />
    </div>
  )
}

export default ForgotPassword
